import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth'
import logs from './modules/logs'
import messages from './modules/messages'
import language from './modules/language'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    language,
    messages,
    auth,
    logs
  },
  state: {
    loading: false,
    title: null,
    tasks: [],
    actions: [],
  },
  getters: {
    isLoading(state) {
      return state.loading
    },
    pageTitle(state) {
      return state.title
    },
    localTasks(state) {
      return state.tasks
    },
    localActions(state) {
      return state.actions
    }
  },
  mutations: {
    setLoading(state, data) {
      Vue.set(state, 'loading', data)
    },

    setPageTitle(state, title) {
      if (typeof title !== "string" || title === "") {
        title = null
      }
      Vue.set(state, 'title', title)
    },

    setLocalTasks(state, tasks) {
      if (tasks === null || tasks instanceof Array === false) {
        Vue.set(state, 'tasks', [])
      } else {
        Vue.set(state, 'tasks', tasks)
      }
    },

    setLocalActions(state, actions) {
      if (actions === null || actions instanceof Array === false) {
        Vue.set(state, 'actions', [])
      } else {
        Vue.set(state, 'actions', actions)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js